export const truncateText = (textDiv, maxLines, originalTextHTML) => {
    if (!originalTextHTML) {
        throw new Error("Error in TextTruncate: originalTextHTML is required");
    }

    // Initialize truncation
    textDiv.innerHTML = originalTextHTML;
    splitTextIntoWords(textDiv);
    truncateToMaxLines(textDiv, maxLines);
    removeWordWrappers(textDiv);

    // Resize listener to re-apply truncation on window resize
    const resizeListener = () => {
        window.removeEventListener("resize", resizeListener);

        textDiv.innerHTML = originalTextHTML;
        splitTextIntoWords(textDiv);
        truncateToMaxLines(textDiv, maxLines);
        removeWordWrappers(textDiv);

        setTimeout(() => {
            window.addEventListener("resize", resizeListener, { passive: true });
        }, 300);
    };
    window.addEventListener("resize", resizeListener);
};

function getTextElement(textDiv) {
    // Finds the appropriate element to apply truncation
    const targetElement = textDiv.querySelector("[data-advisorAdvice]") || textDiv.querySelector("p") || textDiv;
    return targetElement.querySelector("span") || targetElement;
}

function splitTextIntoWords(textDiv) {
    // Wrap each word and <br> with <split> tags for individual handling
    const element = getTextElement(textDiv);
    element.innerHTML = element.innerHTML
        .replace(/<br>/g, " <br> ")
        .split(/\s+/)
        .map(word => word === "<br>" ? word : `<split>${word}</split>`)
        .join(" ");
}

function getLines(textDiv) {
    // Create an array of lines based on word positions
    const lines = [];
    const words = textDiv.querySelectorAll("split");
    let currentLine = [];
    let lastTopPosition;

    words.forEach(word => {
        if (word.offsetTop !== lastTopPosition) {
            // New line detected
            lastTopPosition = word.offsetTop;
            currentLine = [];
            lines.push(currentLine);
        }
        currentLine.push(word);
    });
    return lines;
}

function removeWordWrappers(textDiv) {
    // Remove <split> tags used for word wrapping
    const element = getTextElement(textDiv);
    element.innerHTML = element.innerHTML.replaceAll("<split>", "").replaceAll("</split>", "");
}

function getLastVisibleWord(textDiv, maxLines) {
    // Get the last word in the visible line (determined by maxLines)
    const lines = getLines(textDiv);
    if (lines.length < maxLines) return null;

    const lastLine = lines[maxLines - 1];
    return lastLine[lastLine.length - 1];
}

function truncateToMaxLines(textDiv, maxLines) {
    const lastVisibleWord = getLastVisibleWord(textDiv, maxLines);
    if (!lastVisibleWord) return;

    // Extract text content and truncate if necessary
    const originalText = lastVisibleWord.innerText.trim();
    const lastChar = originalText[originalText.length - 1];
    const isAlphaChar = /[a-zA-Z]$/.test(lastChar);

    // Append ellipsis and truncate based on character type
    if (isAlphaChar) {
        lastVisibleWord.innerText = `${originalText}...`;
    } else {
        lastVisibleWord.innerText = `${originalText.slice(0, -1)}...`;
    }
}
